import { Injectable } from '@angular/core';
import { ProviderService } from '../provider/provider.service';
import { environment } from '../../../../environments/environment';
import { lottoTokenAbi } from '../../json/abis/lottoToken.abi';
import { AbiItem } from 'web3-utils';
import { valueToBigNumber } from '../../helpers/bignumber';

@Injectable({
  providedIn: 'root'
})
export class LottoTokenService {
  constructor(
    private provider: ProviderService
  ) {

  }

  public getLottoContract() {
    return this.provider.getContract(lottoTokenAbi as AbiItem[], environment.contracts.lottoToken)
  }

  public async getLottoBalance() {
    const contract = this.getLottoContract();
    const balance = await contract.balanceOf(this.provider.getCurrentAddress());

    return this.provider.web3.utils.fromWei(balance, 'ether');
  }

  public async getAllowance(spender: string) {
    const contract = this.getLottoContract();

    const allowance = await contract.allowance(this.provider.getCurrentAddress(), spender);

    return this.provider.web3.utils.fromWei(allowance, 'ether');
  }

  public async approve(spender: string, getGas = false) {
    const contract = await this.getLottoContract();
    const approveAmount = '115792089237316195423570985008687907853269984665640564039457584007913129639935';

    if (getGas) {
      const gasPrice = await this.provider.getGasPrice();
      const gasLimit = this.provider.web3.utils.fromWei(
        (await contract.estimateGas.approve(spender, approveAmount)).toString(), 'gwei'
      );
      return valueToBigNumber(gasPrice).multipliedBy(gasLimit.toString()).toString();
    }
    return await contract.approve(spender, approveAmount);
  }

  public async getParticipantsCount() {
    const contract = this.getLottoContract();

    return await contract.participantsCount();
  }

  public async getParticipantsBalances() {
    const contract = this.getLottoContract();

    return await contract.participantsBalances('0', await this.getParticipantsCount());
  }

  public async isLastLottery() {
    const contract = this.getLottoContract();

    return await contract.lastLottery();
  }

  public async getLotteriesCount() {
    const contract = this.getLottoContract();

    return await contract.lotteriesCount();
  }

  public async getCurrentLottery(lotteryId: number) {
    const contract = this.getLottoContract();

    return await contract.getLottery(lotteryId);
  }

  public async getTotalSupply() {
    const contract = this.getLottoContract();

    return await contract.getTotalSupply();
  }
}
